import { Controller } from "@hotwired/stimulus";

/**
 * Ответ на комментарий: подставляет копию основной формы под нужную ветку.
 *
 * Слушает через делегирование, а не вешает обработчик на каждую ссылку при
 * загрузке. Так форма отвечает и на комментарии, пришедшие позже — с Turbo
 * Frame или после отправки, — а прежняя версия про них не знала.
 */
export default class extends Controller {
  static targets = ["form"];
  static values = { placeholder: { type: String, default: "Написать ответ…" } };

  /** Открывает форму ответа под комментарием. */
  open(event) {
    const link = event.target.closest("[data-comment-reply-link]");
    if (!link) return;

    event.preventDefault();

    // Имена классов комментария из макета: .comment и .comment__body.
    const comment = link.closest(".comment");
    const slot = comment?.querySelector(".comment__body");
    if (!comment || !slot) return;

    // Открытая форма всегда одна: вторая сбивала бы с толку.
    this.close();

    const container = document.createElement("div");
    container.className = "reply-form";
    container.appendChild(this.#buildForm(comment.id.replace(/^c/, "")));
    slot.appendChild(container);

    container.querySelector("textarea")?.focus();
  }

  /** Убирает открытую форму ответа. */
  close() {
    this.element.querySelector(".reply-form")?.remove();
  }

  /** Копия основной формы, настроенная на ответ конкретному комментарию. */
  #buildForm(commentId) {
    const form = this.formTarget.cloneNode(true);

    form.querySelector('input[name="reply_to"]')?.remove();
    const replyTo = document.createElement("input");
    replyTo.type = "hidden";
    replyTo.name = "reply_to";
    replyTo.value = commentId;
    form.appendChild(replyTo);

    const textarea = form.querySelector('textarea[name="comment"]');
    if (textarea) {
      textarea.value = "";
      textarea.placeholder = this.placeholderValue;
    }

    const actions = form.querySelector(".comment-form__actions");
    if (actions && !actions.querySelector("[data-action*='comment-reply#close']")) {
      const cancel = document.createElement("button");
      cancel.type = "button";
      cancel.className = "btn btn--outline";
      cancel.textContent = "Отмена";
      cancel.dataset.action = "click->comment-reply#close";
      actions.prepend(cancel);
    }

    return form;
  }
}
